// removed by extract-text-webpack-plugin
module.exports = {"list-exported":"magazines_398m3","informations-pdfs-exported":"magazines_1hgPu","exported-pdf":"magazines_ia236"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ExportedMagazines/styles.scss
// module id = 1269
// module chunks = 1